export default __webpack_public_path__ + "static/media/electricity.66755cc1.svg";